import { useEffect, useState } from 'react';

export interface StorageService {
  get: (key: string) => string | null;
  set: (key: string, value: string) => void;
}

export function useBrowserTab(storageService: StorageService) {
  const key = 'wp_app:instance_id';
  const [sessionStorageId, setSessionStorageId] = useState<string | null>(null);
  const [localStorageId, setLocalStorageId] = useState<string | null>(null);

  const generateId = () => Math.random().toString(36).substr(2, 9);

  useEffect(() => {
    const id = generateId();

    if (!sessionStorageId) {
      const storedSessionStorageId = sessionStorage.getItem(key);
      if (!storedSessionStorageId) {
        sessionStorage.setItem(key, id);
        setSessionStorageId(id);
      } else {
        setSessionStorageId(storedSessionStorageId);
      }
    }

    if (!localStorageId) {
      const storedLocalStorageId = storageService.get(key);
      if (!storedLocalStorageId) {
        if (sessionStorageId) {
          storageService.set(key, sessionStorageId);
          setLocalStorageId(sessionStorageId);
        } else {
          storageService.set(key, id);
          setLocalStorageId(id);
        }
      } else {
        setLocalStorageId(storedLocalStorageId);
      }
    }
  }, [sessionStorageId, localStorageId, storageService]);

  const isAlreadyOpenInAnotherTab = sessionStorageId !== localStorageId;

  return {
    isAlreadyOpenInAnotherTab,
  };
}
